module.exports = __webpack_public_path__ + "vfn-assets/img/review-Gustavo.abd624e2.png";